import {Component, OnInit} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'micro-itsm-findProductType',
  templateUrl: './itsm-findProductType.component.html'
})
export class ItsmFindProductTypeComponent {
  itsmCarrierId:any;
  name:any;
  productType:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
  }

  find() {
    let params: HttpParams = new HttpParams()
      .set('itsmCarrierId', this.itsmCarrierId)
      .set('name', this.name)
    ;

    this.http.get(`${this.env.e.url}/task/itsm/productTypes`, {params: params}).subscribe(
      data => {
        this.productType = data as any;
      }
    );
  }
}
